import { r as registerInstance, c as createEvent, h } from './index-16dc7dde.js';
import { F as html2plain } from './utils-15ad90ec.js';
import './request.constants-deb285e0.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './_commonjsHelpers-ba3f0406.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const selectCss = ":host select{font-size:14px;line-height:20px;width:100%;min-width:250px;max-width:100%;padding:5px 10px;border:1px solid #333333;border-radius:0;box-sizing:border-box}:host select *,:host select *::before,:host select *::after{box-sizing:inherit}@media screen and (min-width: 980px){:host select{width:250px}}";

let PesSelect = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selectedValue = createEvent(this, "selectedValue", 7);
    this.items = [];
  }
  handleSelect(event) {
    this.selectedValue.emit({ selectedValue: event.target.value });
  }
  render() {
    return (h("select", { onChange: (event) => this.handleSelect(event) }, this.items.map((item) => {
      return (h("option", { value: item.value, selected: item.selected === true }, html2plain(item.label)));
    })));
  }
};
PesSelect.style = selectCss;

export { PesSelect as pes_select };
